module.exports = __webpack_public_path__ + "./images/ajax-loader.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/ajax-loader.gif
// module id = 39
// module chunks = 3